import React, { useState, FC, useEffect } from "react";
import TabButton from "../../components/layout/Sections/TabButton";
import TabContent from "../../components/layout/Sections/TabContent";
import Contaier from "../../components/layout/Container/Container";
import Banner from "../../components/layout/Sections/Banner";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { useLocation } from "react-router-dom";
import InspectionProfile from "./InspectionProfile";
import InspectionDashboard from "../DashBoard/Inspection/InspectionDashboard";
const ApplicationForInspection = () => {
  const name = "E-services";
  const name2 = "Application Details";
  const buttonName = "Registration Mode";
  const buttonName2 = "Personal Information";
  const buttonName3 = "Dashboard";
  const buttonName4 = "RFA";
  const location = useLocation();
  const bannerType = location.state;
  const tab = location.state?.activeTab;
  let bannerName = "Schedule a Dragon Fish (Arowana) Harvest Inspection";
  const [activeButton, setActiveButton] = useState<string>("v-pills-home-tab");
  const [activeTab, setActiveTab] = useState<string>("v-pills-home");

  const handleButtonClick = (buttonId: string, tabId: string) => {
    setActiveButton(buttonId);
    setActiveTab(tabId);
  };

  interface TabPages {
    [key: string]: FC<any>; // Use the appropriate prop type for your components
  }

  const tabPages: TabPages = {
    "v-pills-home": InspectionProfile,
    "v-pills-services": InspectionDashboard,
    // "v-pills-rfa": InspectionDashboard,
    // ... add other tab pages here
  };

  const handleProceedClick = () => {
    handleButtonClick("v-pills-profile-tab", "v-pills-profile");
  };

  // useEffect(() => {
  //   if (tab === "dashboard") {
  //     setActiveButton("v-pills-services-tab");
  //     setActiveTab("v-pills-services");
  //   }
  // }, [tab]);

  return (
    <>
      <Header />
      <Contaier>
        <Banner name={bannerName} uiClass="banner-bg" />
        <div className="inner-content">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-2-5">
                <div className="filter-cnt">
                  <h3>{name}</h3>
                  <span>{name2}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-home-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick("v-pills-home-tab", "v-pills-home")
                      }
                    >
                      {buttonName}
                    </TabButton>
                    <TabButton
                      buttonId="v-pills-services-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-services-tab",
                          "v-pills-services"
                        )
                      }
                    >
                      {buttonName3}
                    </TabButton>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-9-5">
                <div className="tab-content" id="v-pills-tabContent">
                  {Object.keys(tabPages).map((tabId) => (
                    <TabContent key={tabId} tabId={tabId} activeTab={activeTab}>
                      {tabPages[tabId]({ RegistrationType: bannerType })}
                    </TabContent>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
};

export default ApplicationForInspection;
